export default "__VITE_ASSET__371f09f0__"